import * as yup from "yup";
import type { DataInitRegister } from "@/modules/login/components/CredencialesForm/CredencialesForm";
import { normalizarTexto } from "@/modules/GestionParteV2/utils/partesIA.utils";
import { PALABRAS_IGNORADAS_RESET_PASSWORD } from "@/modules/login/utils/Url.utils";

export const ChangePasswordFormSchema = (dataInit: DataInitRegister) => yup.object({
    currentPassword: yup
        .string()
        /* .min(10, 'La contraseña debe tener al menos 10 caracteres')
        .matches(ALPHA_NUMERIC, 'La contraseña debe tener letras, números y caracteres')
        .matches(/^\S*$/, "La contraseña no puede contener espacios en blanco") */
        .required('La contraseña es obligatoria'),
    newPassword: yup
        .string()
        .min(10, 'La nueva contraseña debe tener al menos 10 caracteres')
        .matches(/^\S*$/, "La nueva contraseña no puede contener espacios en blanco")
        .test(
            "lowercase",
            "La nueva contraseña debe contener al menos una letra minúscula a-z",
            value => !value || /[a-z]/.test(value)
        )
        .test(
            "uppercase",
            "La nueva contraseña debe contener al menos una letra mayúscula A-Z",
            value => !value || /[A-Z]/.test(value)
        )
        .test(
            "special-char",
            "La nueva contraseña debe contener al menos un carácter especial ! @ # $ % ^ & * - _ + . , ?",
            value => !value || /[^A-Za-z0-9]/.test(value)
        )
        // .test(
        //     "no-personal-data",
        //     "La nueva contraseña no puede contener su nombre, apellido ni cédula",
        //     function (value) {
        //         if (!value) return false;

        //         const password = value.toLowerCase();

        //         const cedula = dataInit.cedula?.toLowerCase() ?? "";
        //         const nombre = dataInit.nombre?.toLowerCase() ?? "";
        //         const apellido = dataInit.apellido?.toLowerCase() ?? "";

        //         const nombresPartes = nombre.split(" ").filter(Boolean);
        //         const apellidosPartes = apellido.split(" ").filter(Boolean);

        //         // Validar cédula completa
        //         if (password.includes(cedula)) return false;

        //         // Validar nombre completo o parcial
        //         if (password.includes(nombre)) return false;
        //         if (nombresPartes.some(n => password.includes(n))) return false;

        //         // Validar apellido completo o parcial
        //         if (password.includes(apellido)) return false;
        //         if (apellidosPartes.some(a => password.includes(a))) return false;

        //         return true;
        //     }
        // )
         .test('no-personal-data', 'La contraseña contiene datos personales', function (value) {

            if (!value) return true;
            
            const { nombre, apellido: apellidos, telefono, fechaNacimiento, cedula } = dataInit;
            const pwd = normalizarTexto(value.toLowerCase(), { eliminarTildes: true });
            const palabrasIgnoradas = PALABRAS_IGNORADAS_RESET_PASSWORD;

            /* Helper para limpiar cadenas y obtener solo dígitos */
            const getDigits = (str: string) => str ? str.replace(/\D/g, '') : '';

            const nombreStr = normalizarTexto((nombre || '').toLowerCase(), { eliminarTildes: true });
            const apellidoStr = normalizarTexto((apellidos || '').toLowerCase(), { eliminarTildes: true });
            const fechaStr = (fechaNacimiento || '').toString();
            const telefonoStr = (telefono || '').toLowerCase();
            const cedulaStr = getDigits(cedula || '');

            const telefonoSoloNumeros = getDigits(telefonoStr);
            const fechaSoloNumeros = getDigits(fechaStr);

            /* Validar nombre */
            const partesNombre = nombreStr.split(' ').filter((p: string) => p && !palabrasIgnoradas.includes(p));
            const tieneMasDeUnNombre = partesNombre.length > 1;
            
            for (const parte of partesNombre) {
                if (pwd.includes(parte)) {
                    return this.createError({
                        message: `${tieneMasDeUnNombre ? "La parte" : "El nombre"} "${parte}" ${tieneMasDeUnNombre ? "del nombre" : ""} no debe ser parte de la contraseña.`
                    });
                }
            }

            /* Validar apellido(s) */
            const partesApellido = apellidoStr.split(' ').filter((p: string) => p && !palabrasIgnoradas.includes(p));
            const tieneMasDeUnApellido = partesApellido.length > 1;

            for (const parte of partesApellido) {
                if (pwd.includes(parte)) {
                    return this.createError({
                        message: `${tieneMasDeUnApellido ? "La parte" : "El apellido"} "${parte}" ${tieneMasDeUnApellido ? "del apellido" : ""} no debe ser parte de la contraseña.`
                    });
                }
            }

            /* Validar fecha */
            if (fechaSoloNumeros && pwd.includes(fechaSoloNumeros)) {
                return this.createError({ message: "La fecha de nacimiento no debe ser parte de la contraseña." });
            }

            /* Validar teléfono */
            if (telefonoSoloNumeros && pwd.includes(telefonoSoloNumeros)) {
                return this.createError({ message: "El teléfono no debe ser parte de la contraseña." });
            }

            /* Validar cédula */
            if (cedulaStr && pwd.includes(cedulaStr)) {
                return this.createError({ message: "La cédula no debe ser parte de la contraseña." });
            }

            return true;
        }),
        // .oneOf([yup.ref('confirmPassword')], 'Las contraseñas deben coincidir')
        // .required('La nueva contraseña es obligatoria'),
    confirmPassword: yup
        .string()
        // .min(10, 'La confirmación de la contraseña debe tener al menos 10 caracteres')
        // .matches(/^\S*$/, "La contraseña no puede contener espacios en blanco")
        // .test(
        //     "lowercase-confirm",
        //     "La confirmación de la contraseña debe contener al menos una letra minúscula a-z",
        //     value => !value || /[a-z]/.test(value)
        // )
        // .test(
        //     "uppercase-confirm",
        //     "La confirmación de la contraseña debe contener al menos una letra mayúscula A-Z",
        //     value => !value || /[A-Z]/.test(value)
        // )
        // .test(
        //     "special-char-confirm",
        //     "La confirmación de la contraseña debe contener al menos un carácter especial ! @ # $ % ^ & * - _ + . , ?",
        //     value => !value || /[^A-Za-z0-9]/.test(value)
        // )
        // .test(
        //     "no-personal-data-confirm",
        //     "La confirmación de la contraseña no puede contener su nombre, apellido ni cédula",
        //     function (value) {
        //         if (!value) return false;

        //         const password = value.toLowerCase();

        //         const cedula = dataInit.cedula?.toLowerCase() ?? "";
        //         const nombre = dataInit.nombre?.toLowerCase() ?? "";
        //         const apellido = dataInit.apellido?.toLowerCase() ?? "";

        //         const nombresPartes = nombre.split(" ").filter(Boolean);
        //         const apellidosPartes = apellido.split(" ").filter(Boolean);

        //         // Validar cédula completa
        //         if (password.includes(cedula)) return false;

        //         // Validar nombre completo o parcial
        //         if (password.includes(nombre)) return false;
        //         if (nombresPartes.some(n => password.includes(n))) return false;

        //         // Validar apellido completo o parcial
        //         if (password.includes(apellido)) return false;
        //         if (apellidosPartes.some(a => password.includes(a))) return false;

        //         return true;
        //     }
        // )
        .oneOf([yup.ref('newPassword')], 'Las contraseñas deben coincidir')
        .required('Debe confirmar la contraseña')
})